/* eslint-disable max-len */
'use strict';

// Invoice email review grid (pages/billing_invoice_email.cfm).
// Booted by js/app/pages/billing_invoice_email.js with values from the page's data attributes.

export function init(config = {}) {

    var $popUserEmailContainer = $('#pagePopUserEmail');
    var $popUserEmailGridContainer = $('#popUserEmailGrid');
    var batchID = config.batchID || '';
    var invoiceBatchNo = config.invoiceBatchNo || '';
    var invoiceNumberMin = config.invoiceNumberMin || '';
    var invoiceNumberMax = config.invoiceNumberMax || '';
    var sendToOutlook = config.sendToOutlook === true;
    var gridDateFormat = config.gridDateFormat || '';

    EQLAPP.COMMON.register({
        'gridID': 'popUserEmailGrid',
    });

    function getPopUserEmailGridBaseURL() {
        var url = '/components/services/transactionalEmail.cfc?' + jQuery.param({
            method: 'getEmailBatchWeb',
            batchID: batchID,
        });
        return url;
    }

    $('.jq_button').button();

    $popUserEmailContainer.find('.js-recipient-bcc').bind('change', function(){
        var $bccInput = $popUserEmailContainer.find('.js-bcc');
        if ($(this).is(':checked')){
            $bccInput.removeClass('hide');
            $bccInput.attr('required', 'required');
            $bccInput.focus();
        } else {
            $bccInput.addClass('hide');
            $bccInput.removeAttr('required');
        }
    });

    $popUserEmailContainer.find('.js-bcc').bind('blur', function(){
        if ($popUserEmailContainer.find('.js-recipient-bcc').is(':checked')){
            this.reportValidity();
        }
    });

    function getOverrideAllEmail() {
        if (!$popUserEmailContainer.find('.js-override-enabled').is(':checked')) {
            return '';
        }
        return $.trim($popUserEmailContainer.find('.js-override-all-email').val());
    }

    // Display only: the grid data and the owners' saved addresses are never changed
    function applyOverrideIndicator() {
        var overrideAllEmail = getOverrideAllEmail();
        $popUserEmailGridContainer.find('.js-override-target').text(overrideAllEmail);
        $popUserEmailContainer.find('.js-email-grid-container').toggleClass('is-override-active', overrideAllEmail.length > 0);
        $popUserEmailContainer.find('.js-override-badge').toggleClass('hide', overrideAllEmail.length < 1);
        updateSelectionSummary();
    }

    function updateSelectionSummary() {
        var selectedIDs = $popUserEmailGridContainer.getGridParam('selarrrow') || [];
        var totalRows = $popUserEmailGridContainer.getDataIDs().length;
        var overrideAllEmail = getOverrideAllEmail();
        var recipients = {};
        var recipientCount = 0;
        var recipientText = '';

        $.each(selectedIDs, (intIndex, rowID) =>{
            var emailAddress = $.trim($popUserEmailGridContainer.jqGrid('getCell', rowID, 'Email')).toLowerCase();
            if (emailAddress.length && !recipients[emailAddress]) {
                recipients[emailAddress] = true;
                recipientCount++;
            }
        });

        if (selectedIDs.length && overrideAllEmail.length) {
            recipientText = 'All going to ' + overrideAllEmail;
        } else if (recipientCount) {
            recipientText = recipientCount === 1 ? 'Sent as 1 email' : 'Sent as ' + recipientCount + ' emails';
        }

        $popUserEmailContainer.find('.js-selection-total').text(selectedIDs.length);
        $popUserEmailContainer.find('.js-selection-label').text(selectedIDs.length === 1 ? 'invoice selected' : 'invoices selected');
        $popUserEmailContainer.find('.js-selection-recipients').text(recipientText);
        $popUserEmailContainer.find('.js-selection-count').text(selectedIDs.length + ' of ' + totalRows + ' selected');
        if (selectedIDs.length) {
            $popUserEmailContainer.find('.js-send-emails').removeAttr('disabled');
        } else {
            $popUserEmailContainer.find('.js-send-emails').attr('disabled', 'disabled');
        }
    }

    $popUserEmailContainer.find('.js-override-enabled').bind('change', function(){
        var $overrideInput = $popUserEmailContainer.find('.js-override-all-email');
        var $overrideHint = $popUserEmailContainer.find('.js-override-hint');
        if ($(this).is(':checked')){
            $overrideInput.removeClass('hide');
            $overrideHint.removeClass('hide');
            $overrideInput.attr('required', 'required');
            $overrideInput.focus();
        } else {
            $overrideInput.addClass('hide');
            $overrideHint.addClass('hide');
            $overrideInput.removeAttr('required');
        }
        applyOverrideIndicator();
    });

    $popUserEmailContainer.find('.js-override-all-email').bind('keyup change', applyOverrideIndicator);

    $popUserEmailContainer.find('.js-override-all-email').bind('blur', function(){
        if ($popUserEmailContainer.find('.js-override-enabled').is(':checked')){
            this.reportValidity();
        }
    });

    function postToPage(url, data = {}, method = 'POST') {
        // Create a form element in memory (not permanently added to DOM)
        const form = document.createElement('form');
        form.action = url;
        form.method = method;
        form.target = '_blank';

        // Add key-value pairs as hidden inputs
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
            }
        }

        // Submit the form
        document.body.appendChild(form); // Add form temporarily to the DOM
        form.submit(); // Submit the form
        document.body.removeChild(form); // Clean up: Remove the form after submission
    }

    $popUserEmailContainer.find('.js-print-single-invoice-pdf').bind('click', (event) =>{
        event.preventDefault();

        postToPage(
            'pages/report_generic.cfm',
            {
                'REPORTFORMAT': 'pdf',
                'reportname': 'billing_invoice_final',
                'batchNo': invoiceBatchNo,
                'invoiceNoFrom': invoiceNumberMin,
                'invoiceNoTo': invoiceNumberMax,
            },
        );

    });

    $popUserEmailContainer.find('.js-zip-single-invoice-pdf').bind('click', (event) =>{
        event.preventDefault();

        postToPage(
            'pages/report_generic.cfm',
            {
                'REPORTFORMAT': 'zip',
                'reportname': 'billing_invoice_final',
                'batchNo': invoiceBatchNo,
                'invoiceNoFrom': invoiceNumberMin,
                'invoiceNoTo': invoiceNumberMax,
            },
        );

    });

    var popUserEmail = {
        url: getPopUserEmailGridBaseURL(),
    };

    var missingEmailTitle = 'Add an email address in the Send To column to select this invoice';

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function formatEmailCell(cellvalue) {
        var email = $.trim(cellvalue == null ? '' : String(cellvalue));
        if (email === '&nbsp;' || email === '&#160;') {
            email = '';
        }
        if (!email.length) {
            return '<span class="ire-email ire-email--missing" data-email="" title="Add an email address for this owner">+ Add email</span>';
        }
        var safeEmail = escapeHtml(email);
        return '<span class="ire-email" data-email="' + safeEmail + '" title="Click to change the email address">'
            + '<span class="ire-email__addr">' + safeEmail + '</span>'
            + '<span class="ire-email__override js-override-target"></span>'
            + '<span class="ire-email__edit" aria-hidden="true">\u270E</span>'
            + '</span>';
    }

    function formatOwnerCell(cellvalue, options, rowObject) {
        var ownerName = cellvalue == null ? '' : String(cellvalue);
        var ownerID = $.isArray(rowObject) ? rowObject[14] : (rowObject && rowObject.OwnerID);
        if (!ownerID) {
            return escapeHtml(ownerName);
        }
        var ownerURL = '/?' + jQuery.param({ page: 'owner', ownerid: ownerID });
        return '<a class="js-owner-link" href="' + escapeHtml(ownerURL) + '" title="Go to owner record">'
            + escapeHtml(ownerName) + '</a>';
    }

    function unformatOwnerCell(cellvalue) {
        return cellvalue;
    }

    function handleOwnerLinkClick(link, e) {
        // Plain left click asks first; Ctrl, Cmd and Shift clicks follow the link as normal
        if (e.which > 1 || e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
        }
        e.preventDefault();
        if (confirm('Go to the owner record for ' + $(link).text() + '?')) {
            window.location.href = link.href;
        }
    }

    // getCell('Email') must keep returning the plain address, not the formatted markup.
    function unformatEmailCell(cellvalue, options, cell) {
        return $(cell).find('.ire-email').attr('data-email') || '';
    }

    function applyMissingEmailState(rowID, isMissing) {
        var $row = $('#' + rowID);
        var $checkbox = $row.find('input.cbox');
        var $checkboxCell = $checkbox.closest('td');

        $row.toggleClass('grid-missing-email', isMissing);
        if (isMissing) {
            $checkbox.attr({ 'aria-disabled': 'true', 'title': missingEmailTitle });
            $checkboxCell.attr('title', missingEmailTitle);
        } else {
            $checkbox.removeAttr('aria-disabled').removeAttr('title');
            $checkboxCell.removeAttr('title');
        }
    }

    function setMissingEmailFilter(showMissingOnly) {
        $popUserEmailContainer.find('.js-email-grid-container').toggleClass('is-missing-only', showMissingOnly);
        $popUserEmailContainer.find('.js-missing-email-filter')
            .text(showMissingOnly ? 'Show all invoices' : 'Show only these');
    }

    function updateMissingEmailNotice() {
        var count = $popUserEmailGridContainer.find('tr.jqgrow.grid-missing-email').length;
        var $notice = $popUserEmailContainer.find('.js-missing-email-notice');

        if (count < 1) {
            $notice.addClass('hide');
            setMissingEmailFilter(false);
            return;
        }

        $notice.find('.js-missing-email-count').text(count === 1 ? '1 invoice has' : count + ' invoices have');
        $notice.removeClass('hide');
    }

    function nudgeAddEmail(rowID) {
        var $addEmail = $('#' + rowID).find('.ire-email--missing');
        $addEmail.removeClass('is-nudged');
        setTimeout(() =>{
            $addEmail.addClass('is-nudged');
            setTimeout(() =>{
                $addEmail.removeClass('is-nudged');
            }, 900);
        }, 10);
    }

    $popUserEmailContainer.find('.js-missing-email-filter').bind('click', (event) =>{
        event.preventDefault();
        var isActive = $popUserEmailContainer.find('.js-email-grid-container').hasClass('is-missing-only');
        setMissingEmailFilter(!isActive);
    });

    $popUserEmailGridContainer.jqGrid({
			 url:	popUserEmail.url
        ,datatype:	'json'
        ,multiselect: true
        ,colNames: [
            'ID'
            ,'UserEmailID'
            ,'InvoiceEmailByDefault'
            ,'Invoice'
            ,'BC ID'
            ,'Invoice Date'
            ,'Owner'
            ,'Send To'
            ,'Details'
            ,'Preview Subject'
            ,'Preview Message'
            ,'Total'
            ,'History'
            ,'Invoice PDF'
            ,'OwnerID',
        ]
        ,colModel: [
            {
                index: 'ID',
                name: 'ID',
                sortable: true,
                sorttype: 'text',
                width: 0,
                hidden: true,
            }
            ,{
                index: 'UserEmailID',
                name: 'UserEmailID',
                sortable: true,
                sorttype: 'text',
                width: 0,
                hidden: true,
            }
            ,{
                index: 'InvoiceEmailByDefault',
                name: 'InvoiceEmailByDefault',
                sortable: false,
                sorttype: 'text',
                width: 0,
                hidden: true,
            }
            ,{
                index: 'Invoice',
                name: 'Invoice',
                sortable: true,
                sorttype: 'text',
                align: 'right',
                width: 48,
                classes: 'pointer',
                editable: false,
            }
            ,{
                index: 'ControlLevel_ID',
                name: 'ControlLevel_ID',
                width: 30,
                align: 'right',
                editable: false,
                hidden: true,
            }
            ,{
                index: 'InvoiceDate',
                name: 'InvoiceDate',
                sortable: true,
                align: 'right',
                width: 70,
                classes: 'pointer',
                editable: false,
                formatter: 'date',
                formatoptions:
                {
                    srcformat: 'Y-m-d'
                    ,newformat: gridDateFormat,
                },
                sorttype: 'Date',
            }
            ,{
                index: 'Owner',
                name: 'Owner',
                sortable: true,
                sorttype: 'text',
                width: 118,
                classes: 'pointer',
                editable: false,
                formatter: formatOwnerCell,
                unformat: unformatOwnerCell,
            }
            ,{
                index: 'Email',
                name: 'Email',
                sortable: true,
                sorttype: 'text',
                width: 128,
                classes: 'pointer email',
                editable: false,
                title: false,
                formatter: formatEmailCell,
                unformat: unformatEmailCell,
            }
            ,{
                index: 'EmailDetails',
                name: 'EmailDetails',
                sortable: false,
                width: 40,
                classes: 'pointer emailDetails option emailInfo',
                editable: false,
            }
            ,{
                index: 'MessageSubject',
                name: 'MessageSubject',
                sortable: false,
                width: 101,
                classes: '',
                editable: false,
                hidden: true,
            }
            ,{
                index: 'MessagePreview',
                name: 'MessagePreview',
                sortable: false,
                width: 101,
                classes: '',
                editable: false,
                hidden: true,
            }
            ,{
                index: 'Total',
                name: 'Total',
                sortable: true,
                sorttype: 'text',
                width: 54,
                classes: 'pointer',
                editable: false,
                formatter: 'number',
                align: 'right',
                sorttype: 'float',
                editoptions: {decimalPlaces: '2'},
            }
            ,{
                index: 'History',
                name: 'History',
                sortable: false,
                width: 53,
                classes: 'pointer option log',
                editable: false,
            }
            ,{
                index: 'PDF',
                name: 'PDF',
                sortable: false,
                width: 65,
                classes: 'pointer option pdf',
                align: 'center',
                editable: false,
            }
            ,{
                index: 'OwnerID',
                name: 'OwnerID',
                sortable: false,
                width: 0,
                hidden: true,
            },
        ]
        ,rowNum: 10000
        ,autowidth: true
        ,height: '100%'
        ,pager: '#popUserEmailGridPager'
        ,sortname: 'ID'
        ,sorttype: 'ASC'
        ,beforeRequest: function(){
            // Hide check all
            //$("#cb_popUserEmailGrid").customHide();
        }
        ,loadComplete: function(){
            gridFix('#popUserEmailGrid');
            var rowIDS = $popUserEmailGridContainer.getDataIDs();
            $.each(rowIDS,(intIndex, rowID) =>{
                var emailAddress = $popUserEmailGridContainer.jqGrid('getCell', rowID,'Email');
                var invoiceEmailByDefault = $popUserEmailGridContainer.jqGrid('getCell', rowID,'InvoiceEmailByDefault');
                var selectedByDefault;

                if (invoiceEmailByDefault != '1'){
                    $('#' + rowID).addClass('grid-do-not-email-default');
                }

                if (emailAddress.length < 1){
                    applyMissingEmailState(rowID, true);
                    selectedByDefault = 0;
                } else {
                    selectedByDefault = invoiceEmailByDefault;
                }

                if (selectedByDefault == 1){
                    $popUserEmailGridContainer.setSelection(rowID, true);
                }

            });
            updateMissingEmailNotice();
            applyOverrideIndicator();
        },
        subGrid: true,
        subGridRowExpanded: function(subgridID, rowID) {
        	// Pass two parameters
        	// subgridID is a id of the div tag created whitin a table data
        	// the id of this elemenet is a combination of the "sg_" + id of the row
        	// the rowID is the id of the row
        	// If we want to pass additional parameters to the url we can use
        	// a method getRowData(rowID) - which returns associative array in type name-value

        	var subgridTableID, pagerID;
        	subgridTableID = subgridID + '_t';
        	pagerID = 'p_' + subgridTableID;
        	$('#' + subgridID).html("<table id='" + subgridTableID + "' class='scroll'></table><div id='" + pagerID + "' class='scroll'></div>");

        	// Subgrid URL
            var invoiceNumber = $popUserEmailGridContainer.jqGrid('getCell', rowID,'Invoice');
            var gridURL = '/components/services/transactionalEmail.cfc?' + jQuery.param({
                method: 'getInvoiceDetailsWeb',
                InvoiceNumber: invoiceNumber,
            });

        	$('#' + subgridTableID).jqGrid({
        		url: gridURL,
        		datatype: 'json',
        		colNames: [
        			'fakeID',
        			'Horse',
        			'Net Amount',
        		],
        		//The Column Model to define the data. Note you can make columns non sortable, specify width, alignment, etc.
        		colModel: [
        			{
                        name: 'ID',
                        index: 'fakeID',
                        width: 80,
                        sorttype: 'int',
                        hidden: true,
                        editable: false,
                        searchoptions: {sopt: ['bw']},
                    },
        			{
                        name: 'HorseName',
                        index: 'HorseName',
                        width: 75,
                        sorttype: 'text',
                        editable: false,
                        searchoptions: {sopt: ['bw']},
                    },
        			{
                        name: 'NetAmount',
                        index: 'NetAmount',
                        width: 25,
                        formatter: 'number',
                        align: 'right',
                        sorttype: 'float',
                        editoptions: {decimalPlaces: '2'},
                    },
        		],
        		rowNum: 10,
        		pager: pagerID,
        		autowidth: true,
        		height: '100%',
        		sortorder: 'DESC',
        		sortname: 'ChangeDate',
        		loadBeforeSend: function()
        		{
        			gridFix('#' + subgridTableID);
        		},
        		loadComplete: function()
        		{
        			var recordsReturned = $('#' + subgridTableID).jqGrid('getDataIDs').length;
        			if (recordsReturned < 1)
        			{
        				$('#' + subgridID).customHide().after("<p id='" + subgridID + "_noresult'>No Records found</p>");
        			}
        			else
        			{
        				$('#' + subgridID + '_noresult').empty().remove();
        				$('#' + subgridID).customShow();
        			}
        		},
        	});

        	$('#' + subgridTableID).addClass('grid_reload');

        },
        onSelectAll: function(aRowids, status) {
            // Rows without an email address must stay unselected. aRowids is the grid's own selarrrow.
            if (status) {
                $popUserEmailGridContainer.find('tr.jqgrow.grid-missing-email').each(function(){
                    var index = $.inArray(this.id, aRowids);
                    if (index > -1) {
                        aRowids.splice(index, 1);
                    }
                    $(this).removeClass('ui-state-highlight').attr('aria-selected', 'false')
                        .find('input.cbox').removeAttr('checked');
                });
                $popUserEmailGridContainer.jqGrid('setGridParam', {
                    selrow: aRowids.length ? aRowids[aRowids.length - 1] : null,
                });
            }
            updateSelectionSummary();
        },
        onSelectRow: function(){
            updateSelectionSummary();
        },
        beforeSelectRow: function(rowid, e){

            var emailID = $popUserEmailGridContainer.jqGrid('getCell', rowid,'ID');
            var emailAddress = $popUserEmailGridContainer.jqGrid('getCell', rowid,'Email');
            var emailSubject = $popUserEmailGridContainer.jqGrid('getCell', rowid,'MessageSubject');
            var emailBody = $popUserEmailGridContainer.jqGrid('getCell', rowid,'MessagePreview');
            var target = e.target || e.srcElement;
            var $ownerLink = $(target).closest('a.js-owner-link');
            if ($ownerLink.length) {
                handleOwnerLinkClick($ownerLink[0], e);
                return false;
            }
            // Cells now hold markup, so read the classes from the cell rather than the clicked element
            var classesList = ($(target).closest('td').attr('class') || '').split(' ');
            var emailAddressClicked = classesList.includes('email');
            var emailDetailsClicked = classesList.includes('emailDetails');

            // Email Details
            if (emailDetailsClicked){
                e.preventDefault();

                var recipientBccChecked = $popUserEmailContainer.find('.js-recipient-bcc').is(':checked');
                var bccAddress = $.trim($popUserEmailContainer.find('.js-bcc').val());
                var previewOptions = {
                    ID: emailID,
                    EmailAddress: emailAddress,
                    Subject: emailSubject,
                    Body: emailBody,
                };

                if (recipientBccChecked && bccAddress.length){
                    previewOptions.BCC = bccAddress;
                }

                EQLAPP.EMAIL.showEmailPreview(previewOptions);
            };

            // Allow user update email of selected contact
            if (emailAddressClicked){
                e.preventDefault();

                var changeEmailURL = '/pages/pop/?' + jQuery.param({
                    module: 'email',
                    page: 'updateEmail',
                    userEmailID: 1,
                    currentEmail: $popUserEmailGridContainer.jqGrid('getCell', rowid, 'Email'),
                });

                popWin({
                    title: $.i18n('Change Email') ,
                    noAutoWidth: true,
                    popID: 'InvoiceChangeEmail',
                    width: 550,
                    modal: true,
                    page: changeEmailURL,
                    buttons: {
                        'Update': function() {
                            const $form = $('#form_email_update');
                            const $email = $form.find("[name='email']");
                            const emailAddress = $email.val();

                            // Validate Email Address
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            const isValidEmail = emailRegex.test(emailAddress);

                            if (!isValidEmail){
                                alert('Invalid email address entered. Please update and try again');
                                return;
                            }

                            // Update Email Address
                            var updateEmailURL = '/components/services/transactionalEmail.cfc?' + jQuery.param({
                                method: 'updateEmailInBatch',
                                ID: rowid,
                                UserEmail: emailAddress,
                            });

                            $.ajax({
                                type: 'POST',
                                url: updateEmailURL,
                                contentType: 'application/json',
                                cache: false,
                                success: function(data){

                                    if (!data?.success){
                                        const errorMessage = (data?.message.length > 0) ? data.message : 'Failed to update email address please try again';
                                        alert(errorMessage);
                                        return;
                                    }

                                    var wasMissingEmail = $('#' + rowid).hasClass('grid-missing-email');

                                    // Update Cell
                                    $popUserEmailGridContainer.jqGrid('setCell', rowid, 'Email', emailAddress);
                                    applyMissingEmailState(rowid, false);
                                    updateMissingEmailNotice();

                                    if (wasMissingEmail && $.inArray(rowid, $popUserEmailGridContainer.getGridParam('selarrrow')) < 0) {
                                        $popUserEmailGridContainer.setSelection(rowid, true);
                                    }
                                    applyOverrideIndicator();

                                    $('#InvoiceChangeEmail').dialog('close');

                                },
                                error: function(){
                                    EQLAPP.STRIPE.showAlert({
                                        title: 'Email Status',
                                        body: 'An issue occured while updating email. Please try again.',
                                    });
                                },
                            });

                        },
                        'Cancel': function() {
                            $(this).dialog('close');
                        },
                    },
                });

                return false;
            }

            // Always allow the user view log history and view invoice PDF
            if (emailAddress.length < 1){
                if (!classesList.includes('pdf') && !classesList.includes('log') && !classesList.includes('emailDetails')){
                    e.preventDefault();
                    nudgeAddEmail(rowid);
                    return false;
                }
            }

            for (var inc = 0; inc < classesList.length; inc++) {

                if (classesList[inc] == 'log') {
                    var invoiceNumber = $popUserEmailGridContainer.jqGrid('getCell', rowid,'Invoice');
                    var historyURL = '/pages/pop/?' + jQuery.param({
                        module: 'invoice',
                        page: 'emailHistory',
                        invoiceNumber: invoiceNumber,
                    });

                    popWin({
                        title: $.i18n('HISTORY') ,
                        noAutoWidth: true,
                        popID: 'ActivityRecord',
                        width: 550,
                        modal: true,
                        page: historyURL,
                        buttons: {
                            'Close': function() {
                                $(this).dialog('close');
                            },
                        },
                    });

                    return false;
                }

                // Show Invoice PDF
                if (classesList[inc] == 'pdf') {
                    var invoiceNumber = $popUserEmailGridContainer.jqGrid('getCell', rowid,'Invoice');
                    var controlLevelID = $popUserEmailGridContainer.jqGrid('getCell', rowid,'ControlLevel_ID');
                    EQLAPP.BILLING.showInvoicePDF({
                        invoiceNumber: invoiceNumber,
                        controlLevelID: controlLevelID,
                    });
                }
            }

            return true;
        },

    });

    $popUserEmailContainer.find('.js-send-emails').bind('click', (event) =>{
        event.preventDefault();

        var recipientBCC = $popUserEmailContainer.find('.js-recipient-bcc').is(':checked');
        var $bccInput = $popUserEmailContainer.find('.js-bcc');
        var bccAddress = '';
        if (recipientBCC){
            bccAddress = $.trim($bccInput.val());
            $bccInput.val(bccAddress);
            if (!$bccInput[0].reportValidity()){
                return;
            }
        }

        var overrideEnabled = $popUserEmailContainer.find('.js-override-enabled').is(':checked');
        var $overrideInput = $popUserEmailContainer.find('.js-override-all-email');
        if (overrideEnabled){
            $overrideInput.val($.trim($overrideInput.val()));
            if (!$overrideInput[0].reportValidity()){
                return;
            }
        }

        var emailIDs = $('#popUserEmailGrid').getGridParam('selarrrow');
        var overrideAllEmail = getOverrideAllEmail();
        var confirmMessage;

        if (overrideAllEmail.length) {
            confirmMessage = 'All ' + emailIDs.length + ' selected invoice' + (emailIDs.length === 1 ? '' : 's')
                + (sendToOutlook ? ' will be drafted to ' : ' will be sent to ')
                + overrideAllEmail + ' instead of the owners. Continue?';
        } else {
            confirmMessage = sendToOutlook
                ? 'Are you sure you want to create Outlook drafts for the selected Owners?'
                : 'Are you sure you want to send invoices to selected Owners?';
        }

        if (!confirm(confirmMessage)){
            return;
        }

        if (emailIDs.length < 1){
            EQLAPP.STRIPE.showAlert({
                title: 'No Email Selected',
                body: 'No Email Selected. Please select at least one email any try again.',
            });
            return;
        }

        var sendURL = '/components/services/transactionalEmail.cfc?method=processEmailWeb';

        var postData = {
            emailInvoiceID: emailIDs,
            overrideAllEmail: overrideAllEmail,
            RecipientBCC: recipientBCC,
            BCC: recipientBCC ? bccAddress : '',
        };

        $.ajax({
            type: 'POST',
            url: sendURL,
            data: JSON.stringify(postData),
            contentType: 'application/json',
            cache: false,
            success: function(data){

                if (!data.success){
                    EQLAPP.STRIPE.showAlert({
                        title: 'Email Status - Check Inquiry',
                        body: data.message,
                    });

                    if (data.totalerrors > 0){
                        console.log('Errors', data.totalerrors);
                    }

                    return;
                }

                var changeEmailURL = '/pages/pop/?' + jQuery.param({
                    module: 'email',
                    page: 'sentEmailConfirmation',
                    sendMode: data.sendMode || '',
                });

                popWin({
                    title: $.i18n('Success') ,
                    noAutoWidth: true,
                    popID: 'sentEmailConfirmationPop',
                    width: 550,
                    modal: true,
                    page: changeEmailURL,
                    buttons: {
                        'Close': function() {
                            $(this).dialog('close');
                        },
                    },
                });
            },
            error: function(){
                EQLAPP.STRIPE.showAlert({
                    title: 'Email Status',
                    body: 'An issue occured sending emails. Please try again.',
                });
            },
        });

    });

}
